


// import React, { useState } from 'react';
// import { MdStar, MdStarHalf, MdStarOutline, MdArrowBackIos, MdArrowForwardIos } from 'react-icons/md'; // Import arrow icons
// import { useSwipeable } from 'react-swipeable'; // Import swipeable
// import images from '../../../images.config';
// import icons from "../../../icons.config";

// const Testimonials = () => {
//   const testimonials = [
//     {
//       id: 1,
//       text: "This is a great service!",
//       bigImage: {
//         image: images.testimonialBig,
//         alt: "Testimonial Image 5",
//         name: "SASHA",
//         place: "Chandigarh",
//         description: "A perfect balance of style and comfort.",
//         rating: 4.5
//       },
//       smallImages: [
//         { image: images.testimonial1, alt: "Testimonial Image 1", name: "ALIA BHATT", place: "Mumbai", description: "Dikost's custom sizing is a game-changer!", rating: 5 },
//         { image: images.testimonial2, alt: "Testimonial Image 2", name: "RAKULPREET KAUR", place: "Gurgaon", description: "Finally, a brand that understands style and fit!", rating: 3.5 },
//         { image: images.testimonial3, alt: "Testimonial Image 3", name: "KIARA ADVANI", place: "Bangalore", description: "I feel confident and chic in every outfit!", rating: 2.5 },
//         { image: images.testimonial2, alt: "Testimonial Image 4", name: "DEEPIKA", place: "Delhi", description: "The outfits perfectly match my personality.", rating: 5 },
//       ],
//     }
//   ];

//   const renderStars = (rating) => {
//     const fullStars = Math.floor(rating);
//     const halfStars = rating % 1 !== 0 ? 1 : 0;
//     const emptyStars = 5 - fullStars - halfStars;

//     return (
//       <div className="flex space-x-1">
//         {Array(fullStars).fill(<MdStar className="text-review" />)}
//         {halfStars === 1 && <MdStarHalf className="text-review" />}
//         {Array(emptyStars).fill(<MdStarOutline className="text-review" />)}
//       </div>
//     );
//   };

//   const [activeTestimonial, setActiveTestimonial] = useState(testimonials[0]);
//   const [isFading, setIsFading] = useState(false);
//   const [currentIndex, setCurrentIndex] = useState(0); // Track the current index of displayed small images
//   const [isSliding, setIsSliding] = useState(false); // State to control sliding effect

//   const slideDuration = 500; // Duration for sliding effect (in milliseconds)

//   const handleSmallImageClick = (clickedImage) => {
//     setIsFading(true); // Start fading

//     setTimeout(() => {
//       const currentBigImage = activeTestimonial.bigImage;
//       const clickedIndex = activeTestimonial.smallImages.findIndex(
//         imageObj => imageObj.image === clickedImage.image
//       );

//       const reorderedSmallImages = [
//         ...activeTestimonial.smallImages.slice(clickedIndex + 1),
//         ...activeTestimonial.smallImages.slice(0, clickedIndex),
//         currentBigImage,
//       ];

//       setActiveTestimonial(prev => ({
//         ...prev,
//         bigImage: clickedImage,
//         smallImages: reorderedSmallImages
//       }));
//       setIsFading(false); // Stop fading after images have swapped
//     }, 500); // Delay to match the fade effect duration
//   };

//   // Handlers for swipe actions
//   const handleNext = () => {
//     setCurrentIndex(prev => (prev + 2) % activeTestimonial.smallImages.length);
//   };
  

//   const handlePrev = () => {
//     setCurrentIndex(prev => (prev - 2 + activeTestimonial.smallImages.length) % activeTestimonial.smallImages.length);
//   };
//   const handleNextLarge = () => {
//     if (!isSliding) {
//       setIsSliding(true);

//       setTimeout(() => {
//         setActiveTestimonial(prev => {
//           const { smallImages } = prev;
//           const lastImage = smallImages[smallImages.length - 1];
//           const updatedSmallImages = [lastImage, ...smallImages.slice(0, smallImages.length - 1)];
//           return {
//             ...prev,
//             smallImages: updatedSmallImages,
//           };
//         });

//         setIsSliding(false);
//       }, slideDuration);
//     }
//   };

//   const handlePrevLarge = () => {
//     if (!isSliding) {
//       setIsSliding(true);

//       setTimeout(() => {
//         setActiveTestimonial(prev => {
//           const { smallImages } = prev;
//           const firstImage = smallImages[0];
//           const updatedSmallImages = [...smallImages.slice(1), firstImage];
//           return {
//             ...prev,
//             smallImages: updatedSmallImages,
//           };
//         });

//         setIsSliding(false);
//       }, slideDuration);
//     }
//   };

//   // Swipeable configuration
//   const handlers = useSwipeable({
//     onSwipedLeft: handleNext,
//     onSwipedRight: handlePrev,
//     preventDefaultTouchmoveEvent: true,
//     trackMouse: true,
//   });

//   return (
//       <div {...handlers} className="mx-auto h-[100%]  px-4 pt-2 pb-20 lg:pb-48 2xl:pb-32 xl:py-5 bottom-0 relative bg-tertiary overflow-hidden">
//         <div className="hidden lg:block relative lg:left-[35%] top-6 z-10">
//         <img src={icons.collectionFlower} alt="Doodle Left" className="lg:w-20" />
//       </div>
//       <div className="lg:hidden relative left-[3%] md:left-[26%] top-12 z-10">
//         <img src={icons.collectionFlower} alt="Doodle Left" className="w-16" />
//       </div>
//         <h2 className="text-3xl font-outfit font-light text-center mb-12 text-primary1 relative bottom-8">TESTIMONIALS</h2>

//         <div className="hidden lg:flex relative lg:left-28">
//           <div className="flex-1 text-left relative top-20">
//             {renderStars(activeTestimonial.bigImage.rating)}
//             <h3 className="text-3xl font-outfit font-normal text-primary1">{activeTestimonial.bigImage.name}</h3>
//             <h3 className="text-2xl font-outfit font-light text-hcolor">{activeTestimonial.bigImage.place}</h3>
//             <p className="text-md font-poppins font-light text-hcolor mt-5">{activeTestimonial.bigImage.description}</p>

//             <div className="flex space-x-1 mt-4 relative lg:top-32 ">
//               {/* Previous Arrow */}
//               <div className='relative xl:top-80 2xl:top-36 right-2'>
//               <img src={icons.arrowLeft} alt="left arrow"
//                 className="text-hcolor cursor-pointer bg-secondary rounded-full h-7 w-7 relative  z-10"
//                 onClick={handlePrevLarge}
//               />
//               </div>
             

//               {/* Small Images */}
//               <div className='flex gap-x-4 relative right-7 xl:-bottom-60 2xl:-bottom-16'>
//               {activeTestimonial.smallImages.slice(currentIndex, currentIndex + 4).map((imageObj, index) => (
//                 <div key={index} className="flex flex-col items-center space-y-1  ">
//                   <img
//                     src={imageObj.image}
//                     alt={imageObj.alt}
//                     className={`w-[180px] h-[180px]  object-cover cursor-pointer transition-opacity duration-500 ${isFading ? 'opacity-0' : 'opacity-100'}`}
//                     onClick={() => handleSmallImageClick(imageObj)}
//                   />
//                   {renderStars(imageObj.rating)}
//                   <h3 className="text-md font-outfit font-normal text-primary1 whitespace-nowrap truncate">{imageObj.name}</h3>

//                   <h4 className="text-sm font-outfit font-light text-hcolor">{imageObj.place}</h4>
//                 </div>
//               ))}
//               </div>

//               {/* Next Arrow */}
//               <div className='relative xl:top-80 2xl:top-36 right-10'>
//               <img src={icons.arrowRight} alt="right arrow"
//                 className="text-hcolor cursor-pointer rounded-full bg-secondary h-7 w-7"
//                 onClick={handleNextLarge}
//               />
//               </div>
              
//             </div>
//           </div>
//           <div className="flex-1 relative left-20">
//             <img
//               src={activeTestimonial.bigImage.image}
//               alt={activeTestimonial.bigImage.alt}
//               className={` lg:w-[300px] xl:w-[480px] 2xl:w-[530px] xl:h-screen lg:h-[80%] py-12 object-cover transition-opacity duration-500  ${isFading ? 'opacity-0' : 'opacity-100'} relative right-24`}
//             />
//           </div>
//         </div>

//         <div className="lg:hidden flex flex-col items-center">
//           <img
//             src={activeTestimonial.bigImage.image}
//             alt={activeTestimonial.bigImage.alt}
//             className={`w-[85%] md:w-full h-auto md:h-[50%] object-cover mb-4 md:max-w-[680px] transition-opacity duration-500 ${isFading ? 'opacity-0' : 'opacity-100'}`}
//           />
//           <div className="flex flex-col items-start w-full relative left-7 md:left-10">
//             {renderStars(activeTestimonial.bigImage.rating)}
//             <h3 className="text-3xl font-outfit font-normal text-primary1">{activeTestimonial.bigImage.name}</h3>
//             <h3 className="text-2xl font-outfit font-light text-hcolor">{activeTestimonial.bigImage.place}</h3>
//             <p className="text-md font-poppins font-light text-hcolor mt-1">{activeTestimonial.bigImage.description}</p>
//           </div>

//           <div className="flex space-x-5 mb-4 mt-16 relative left-2 md:left-0">
//             {activeTestimonial.smallImages.slice(currentIndex, currentIndex + 2).map((imageObj, index) => (
//                <div key={index} className="flex flex-col text-nowrap space-y-1 ">
//               <img
//                 key={index}
//                 src={imageObj.image}
//                 alt={imageObj.alt}
//                 className={`w-40 h-40 md:w-48 md:h-48 object-fit cursor-pointer transition-opacity duration-500 ${isFading ? 'opacity-0' : 'opacity-100'}`}
//                 onClick={() => handleSmallImageClick(imageObj)}
//               />
//               {renderStars(imageObj.rating)}
//               <h3 className="text-md font-outfit font-normal text-primary1 whitespace-nowrap truncate">{imageObj.name}</h3>

//               <h4 className="text-sm font-outfit font-light text-hcolor">{imageObj.place}</h4>
//               </div>
//             ))}
//           </div>

//           <div className="flex justify-center">
//               {Array(Math.ceil(activeTestimonial.smallImages.length / 2)).fill().map((_, index) => (
//                 <div
//                   key={index}
//                   className={`h-2 w-2 md:h-3 md:w-3 rounded-full mx-1 ${currentIndex === index * 2 ? 'bg-primary1' : 'bg-primary2'}`}
//                 />
//               ))}
//           </div>
//         </div>
//       </div>
//   );
// };

// export default Testimonials;

















































// import React, { useState, useEffect } from 'react';
// import { MdStar, MdStarHalf, MdStarOutline } from 'react-icons/md'; // Importing necessary icons
// import { useSwipeable } from 'react-swipeable'; // Import swipeable functionality
// import icons from "../../../icons.config";
// import { IMAGE_URL } from '../../../api-urls';

// const Testimonials = ({ testimonialsData }) => {
  // const [activeTestimonial, setActiveTestimonial] = useState(
  //   testimonialsData && testimonialsData.length > 0 ? testimonialsData[0] : null
  // );
//   const [isFading, setIsFading] = useState(false);
//   const [currentIndex, setCurrentIndex] = useState(0); // Track the current index of displayed small images
//   const [isSliding, setIsSliding] = useState(false); // State to control sliding effect

//   const slideDuration = 500; // Duration for sliding effect (in milliseconds)

  // const renderStars = (rating) => {
  //   if (!rating) return null; 
  //   const fullStars = Math.floor(rating);
  //   const halfStars = rating % 1 !== 0 ? 1 : 0;
  //   const emptyStars = 5 - fullStars - halfStars;

  //   return (
  //     <div className="flex space-x-1">
  //       {Array(fullStars).fill(<MdStar className="text-review" />)}
  //       {halfStars === 1 && <MdStarHalf className="text-review" />}
  //       {Array(emptyStars).fill(<MdStarOutline className="text-review" />)}
  //     </div>
  //   );
  // };

  // const handleSmallImageClick = (clickedImage) => {
  //   setIsFading(true); // Start fading
  //   setTimeout(() => {
  //     setActiveTestimonial(prev => ({
  //       ...prev,
  //       bigImage: clickedImage,
  //     }));
  //     setIsFading(false); // Stop fading after images have swapped
  //   }, 500); // Delay to match the fade effect duration
  // };

//   const handleNext = () => {
//     setCurrentIndex(prev => (prev + 1) % testimonialsData.length);
//   };

//   const handlePrev = () => {
//     setCurrentIndex(prev => (prev - 1 + testimonialsData.length) % testimonialsData.length);
//   };

//   // Swipeable configuration
//   const handlers = useSwipeable({
//     onSwipedLeft: handleNext,
//     onSwipedRight: handlePrev,
//     preventDefaultTouchmoveEvent: true,
//     trackMouse: true,
//   });

  // useEffect(() => {
  //   if (testimonialsData && testimonialsData.length > 0) {
  //     setActiveTestimonial(testimonialsData[0]);
  //   }
  // }, [testimonialsData]);

  // if (!activeTestimonial) {
  //   return <div>Loading...</div>; // Show a loading message or placeholder
  // }

//   return (
//     <div {...handlers} className="mx-auto px-4 pt-2 pb-20 lg:pb-48 2xl:pb-32 xl:py-5 relative bg-tertiary overflow-hidden">
//       <h2 className="text-3xl font-outfit font-light text-center mb-12 text-primary1 relative bottom-8">TESTIMONIALS</h2>
//       <div className="flex justify-between items-center">
//         <div className="flex-1 text-left relative top-20">
//           {renderStars(activeTestimonial.rating)}
//           <h3 className="text-3xl font-outfit font-normal text-primary1">{activeTestimonial.name}</h3>
//           <h3 className="text-2xl font-outfit font-light text-hcolor">{activeTestimonial.city}</h3>
//           <p className="text-md font-poppins font-light text-hcolor mt-5">{activeTestimonial.testimonial}</p>

//           <div className="flex space-x-1 mt-4">
//             {/* Previous Arrow */}
//             <img src={icons.arrowLeft} alt="left arrow" className="cursor-pointer bg-secondary rounded-full h-7 w-7" onClick={handlePrev} />
//             {/* Next Arrow */}
//             <img src={icons.arrowRight} alt="right arrow" className="cursor-pointer bg-secondary rounded-full h-7 w-7" onClick={handleNext} />
//           </div>
//         </div>

//         {/* Testimonial Image */}
//         <div className="flex-1 relative">
//           <img
//             src={IMAGE_URL+activeTestimonial.image}
//             alt={activeTestimonial.name}
//             className={`lg:w-[300px] xl:w-[480px] 2xl:w-[530px] object-cover transition-opacity duration-500 ${isFading ? 'opacity-0' : 'opacity-100'}`}
//           />
//         </div>
//       </div>

//       {/* Smaller Images Section */}
//       <div className="flex justify-center mt-12">
//         {testimonialsData.map((testimonial, index) => (
//           <div key={index} className="flex flex-col items-center space-y-2">
//             <img
//               src={IMAGE_URL+testimonial.image}
//               alt={testimonial.name}
//               className="w-32 h-32 object-cover cursor-pointer"
//               onClick={() => handleSmallImageClick(testimonial)}
//             />
//             {renderStars(testimonial.rating)}
//             <h3 className="text-md font-outfit font-normal text-primary1">{testimonial.name}</h3>
//             <h4 className="text-sm font-outfit font-light text-hcolor">{testimonial.city}</h4>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default Testimonials;

// import React, { useState,useEffect } from 'react';
// import { MdStar, MdStarHalf, MdStarOutline, MdArrowBackIos, MdArrowForwardIos } from 'react-icons/md'; // Import arrow icons
// import { useSwipeable } from 'react-swipeable'; // Import swipeable
// import images from '../../../images.config';
// import icons from "../../../icons.config";

// const Testimonials = ({ testimonialsData }) => {
  
//   //   {
//   //     id: 1,
//   //     text: "This is a great service!",
//   //     bigImage: {
//   //       image: images.testimonialBig,
//   //       alt: "Testimonial Image 5",
//   //       name: "SASHA",
//   //       place: "Chandigarh",
//   //       description: "A perfect balance of style and comfort.",
//   //       rating: 4.5
//   //     },
//   //     smallImages: [
//   //       { image: images.testimonial1, alt: "Testimonial Image 1", name: "ALIA BHATT", place: "Mumbai", description: "Dikost's custom sizing is a game-changer!", rating: 5 },
//   //       { image: images.testimonial2, alt: "Testimonial Image 2", name: "RAKULPREET KAUR", place: "Gurgaon", description: "Finally, a brand that understands style and fit!", rating: 3.5 },
//   //       { image: images.testimonial3, alt: "Testimonial Image 3", name: "KIARA ADVANI", place: "Bangalore", description: "I feel confident and chic in every outfit!", rating: 2.5 },
//   //       { image: images.testimonial2, alt: "Testimonial Image 4", name: "DEEPIKA", place: "Delhi", description: "The outfits perfectly match my personality.", rating: 5 },
//   //     ],
//   //   }
//   // ];
  
//   const renderStars = (rating) => {
//     if (!rating) return null; 
//     const fullStars = Math.floor(rating);
//     const halfStars = rating % 1 !== 0 ? 1 : 0;
//     const emptyStars = 5 - fullStars - halfStars;

//     return (
//       <div className="flex space-x-1">
//         {Array(fullStars).fill(<MdStar className="text-review" />)}
//         {halfStars === 1 && <MdStarHalf className="text-review" />}
//         {Array(emptyStars).fill(<MdStarOutline className="text-review" />)}
//       </div>
//     );
//   };

//   useEffect(() => {
//     if (testimonialsData && testimonialsData.length > 0) {
//       setActiveTestimonial(testimonialsData[0]);
//     }
//   }, [testimonialsData]);
//   const [activeTestimonial, setActiveTestimonial] = useState(
//     testimonialsData && testimonialsData.length > 0 ? testimonialsData[0] : null
//   );
//   const [isFading, setIsFading] = useState(false);
//   const [currentIndex, setCurrentIndex] = useState(0); // Track the current index of displayed small images
//   const [isSliding, setIsSliding] = useState(false); // State to control sliding effect
//   const [clickedImage, setClickedImage] = useState(null);

//   const slideDuration = 500; // Duration for sliding effect (in milliseconds)


//   //   setIsFading(true); // Start fading

//   //   setTimeout(() => {
//   //     const currentBigImage = activeTestimonial.bigImage;
//   //     const clickedIndex = activeTestimonial.smallImages.findIndex(
//   //       imageObj => imageObj.image === clickedImage.image
//   //     );

//   //     const reorderedSmallImages = [
//   //       ...activeTestimonial.smallImages.slice(clickedIndex + 1),
//   //       ...activeTestimonial.smallImages.slice(0, clickedIndex),
//   //       currentBigImage,
//   //     ];

//   //     setActiveTestimonial(prev => ({
//   //       ...prev,
//   //       bigImage: clickedImage,
//   //       smallImages: reorderedSmallImages
//   //     }));
//   //     setIsFading(false); // Stop fading after images have swapped
//   //   }, 500); // Delay to match the fade effect duration
//   // };

//   // Handlers for swipe actions
  
  
//   const handleSmallImageClick = (clickedImage) => {
//     setIsFading(true); // Start fading
//     setTimeout(() => {
//       setActiveTestimonial(prev => ({
//         ...prev,
//         bigImage: clickedImage, // Update the big image with clicked small image
//         name: clickedImage.name, // Update name
//         city: clickedImage.place, // Update city
//         description: clickedImage.description, // Update description
//         rating: clickedImage.rating, // Update rating
//       }));
//       setIsFading(false); // Stop fading after images have swapped
//     }, 500); // Delay to match the fade effect duration
//   };
  
  

  
  // const handleNext = () => {
  //   setCurrentIndex(prev => (prev + 2) % activeTestimonial.smallImages.length);
  // };
  

  // const handlePrev = () => {
  //   setCurrentIndex(prev => (prev - 2 + activeTestimonial.smallImages.length) % activeTestimonial.smallImages.length);
  // };
  // const handleNextLarge = () => {
  //   if (!isSliding) {
  //     setIsSliding(true);

  //     setTimeout(() => {
  //       setActiveTestimonial(prev => {
  //         const { smallImages } = prev;
  //         const lastImage = smallImages[smallImages.length - 1];
  //         const updatedSmallImages = [lastImage, ...smallImages.slice(0, smallImages.length - 1)];
  //         return {
  //           ...prev,
  //           smallImages: updatedSmallImages,
  //         };
  //       });

  //       setIsSliding(false);
  //     }, slideDuration);
  //   }
  // };

  // const handlePrevLarge = () => {
  //   if (!isSliding) {
  //     setIsSliding(true);

  //     setTimeout(() => {
  //       setActiveTestimonial(prev => {
  //         const { smallImages } = prev;
  //         const firstImage = smallImages[0];
  //         const updatedSmallImages = [...smallImages.slice(1), firstImage];
  //         return {
  //           ...prev,
  //           smallImages: updatedSmallImages,
  //         };
  //       });

  //       setIsSliding(false);
  //     }, slideDuration);
  //   }
  // };

  // // Swipeable configuration
  // const handlers = useSwipeable({
  //   onSwipedLeft: handleNext,
  //   onSwipedRight: handlePrev,
  //   preventDefaultTouchmoveEvent: true,
  //   trackMouse: true,
  // });
  

//   if (!activeTestimonial) {
//     return <div>Loading...</div>; // Show a loading message or placeholder
//   }

//   return (
//       <div {...handlers} className="mx-auto h-[100%]  px-4 pt-2 pb-20 lg:pb-48 2xl:pb-32 xl:py-5 bottom-0 relative bg-tertiary overflow-hidden">
//         <div className="hidden lg:block relative lg:left-[35%] top-6 z-10">
//         <img src={icons.collectionFlower} alt="Doodle Left" className="lg:w-20" />
//       </div>
//       <div className="lg:hidden relative left-[3%] md:left-[26%] top-12 z-10">
//         <img src={icons.collectionFlower} alt="Doodle Left" className="w-16" />
//       </div>
//         <h2 className="text-3xl font-outfit font-light text-center mb-12 text-primary1 relative bottom-8">TESTIMONIALS</h2>

//         <div className="hidden lg:flex relative lg:left-28">
//           <div className="flex-1 text-left relative top-20">
//           {renderStars(activeTestimonial.rating)}
//             <h3 className="text-3xl font-outfit font-normal text-primary1">{activeTestimonial.name}</h3>
//             <h3 className="text-2xl font-outfit font-light text-hcolor">{activeTestimonial.city}</h3>
//             <p className="text-md font-poppins font-light text-hcolor mt-5">{activeTestimonial.testimonial}</p>

//             <div className="flex space-x-1 mt-4 relative lg:top-32 ">
//               {/* Previous Arrow */}
//               <div className='relative xl:top-80 2xl:top-36 right-2'>
//               <img src={icons.arrowLeft} alt="left arrow"
//                 className="text-hcolor cursor-pointer bg-secondary rounded-full h-7 w-7 relative  z-10"
//                 onClick={handlePrevLarge}
//               />
//               </div>
             

//               {/* Small Images */}
//               <div className='flex gap-x-4 relative right-7 xl:-bottom-60 2xl:-bottom-16'>
//               {(activeTestimonial?.smallImages || []).slice(currentIndex, currentIndex + 4).map((imageObj, index) => (

//                 <div key={index} className="flex flex-col items-center space-y-1  ">
//                   <img
//                     src={clickedImage.image}
//                     alt={clickedImage.alt}
//                     className={`w-[180px] h-[180px]  object-cover cursor-pointer transition-opacity duration-500 ${isFading ? 'opacity-0' : 'opacity-100'}`}
//                     onClick={() => handleSmallImageClick(clickedImage)}
//                   />
//                   {renderStars(clickedImage.rating)}
//                   <h3 className="text-md font-outfit font-normal text-primary1 whitespace-nowrap truncate">{imageObj.name}</h3>

//                   <h4 className="text-sm font-outfit font-light text-hcolor">{imageObj.place}</h4>
//                 </div>
//               ))}
//               </div>

//               {/* Next Arrow */}
//               <div className='relative xl:top-80 2xl:top-36 right-10'>
//               <img src={icons.arrowRight} alt="right arrow"
//                 className="text-hcolor cursor-pointer rounded-full bg-secondary h-7 w-7"
//                 onClick={handleNextLarge}
//               />
//               </div>
              
//             </div>
//           </div>
//           <div className="flex-1 relative left-20">
//             <img
//               src={activeTestimonial.image}
//               alt={activeTestimonial.isApproved}
//               className={` lg:w-[300px] xl:w-[480px] 2xl:w-[530px] xl:h-screen lg:h-[80%] py-12 object-cover transition-opacity duration-500  ${isFading ? 'opacity-0' : 'opacity-100'} relative right-24`}
//             />
//           </div>
//         </div>

//         <div className="lg:hidden flex flex-col items-center">
//           <img
//             src={activeTestimonial.image}
//             alt={activeTestimonial.isApproved}
//             className={`w-[85%] md:w-full h-auto md:h-[50%] object-cover mb-4 md:max-w-[680px] transition-opacity duration-500 ${isFading ? 'opacity-0' : 'opacity-100'}`}
//           />
//           <div className="flex flex-col items-start w-full relative left-7 md:left-10">
//             {renderStars(activeTestimonial.rating)}
//             <h3 className="text-3xl font-outfit font-normal text-primary1">{activeTestimonial.name}</h3>
//             <h3 className="text-2xl font-outfit font-light text-hcolor">{activeTestimonial.city}</h3>
//             <p className="text-md font-poppins font-light text-hcolor mt-1">{activeTestimonial.testimonial}</p>
//           </div>

//           <div className="flex space-x-5 mb-4 mt-16 relative left-2 md:left-0">
//           {(activeTestimonial?.smallImages || []).slice(currentIndex, currentIndex + 4).map((imageObj, index) => (

//   <div key={index} className="flex flex-col items-center space-y-1">
//     <img
//       src={imageObj.image}  // Fix: Use imageObj, not clickedImage
//       alt={imageObj.isApproved}
//       className={`w-[180px] h-[180px] object-cover cursor-pointer transition-opacity duration-500 ${isFading ? 'opacity-0' : 'opacity-100'}`}
//       onClick={() => handleSmallImageClick(imageObj)} // Pass imageObj, not clickedImage
//     />
//     {renderStars(imageObj.rating)}
//     <h3 className="text-md font-outfit font-normal text-primary1 whitespace-nowrap truncate">{imageObj.name}</h3>
//     <h4 className="text-sm font-outfit font-light text-hcolor">{imageObj.city}</h4>
//   </div>
// ))}

//           </div>

//           <div className="flex justify-center">
//   {Array(Math.ceil((activeTestimonial?.smallImages?.length || 0) / 2))
//     .fill()
//     .map((_, index) => (
//       <div
//         key={index}
//         className={`h-2 w-2 md:h-3 md:w-3 rounded-full mx-1 ${
//           currentIndex === index * 2 ? 'bg-primary1' : 'bg-primary2'
//         }`}
//       />
//     ))}
// </div>

//         </div>
//       </div>
//   );
// };

// export default Testimonials;
// import React, { useState, useEffect } from "react";
// import { MdStar, MdStarHalf, MdStarOutline } from "react-icons/md";
// import { useSwipeable } from "react-swipeable";
// import icons from '../../../icons.config'; // Adjust the path accordingly
// import { IMAGE_URL } from "../../../api-urls";
// import Lottie from "lottie-react";
// import loadingAnimation from '../../../Assets/loadingAnimation.json'

// const Testimonials = ({ testimonialsData }) => {
//   const [activeTestimonial, setActiveTestimonial] = useState(null);
//   const [smallImages, setSmallImages] = useState([]);
//   const [isFading, setIsFading] = useState(false);
//   const [isSliding, setIsSliding] = useState(false);
//   const slideDuration = 500;

//   useEffect(() => {
//     if (testimonialsData && testimonialsData.length > 0) {
//       setActiveTestimonial(testimonialsData[0]);
//       setSmallImages(testimonialsData.slice(1));
//     }
//   }, [testimonialsData]);

//   const renderStars = (rating) => {
//     if (!rating) return null;
//     const fullStars = Math.floor(rating);
//     const halfStars = rating % 1 !== 0 ? 1 : 0;
//     const emptyStars = 5 - fullStars - halfStars;

//     return (
//       <div className="flex space-x-1">
//         {Array(fullStars).fill().map((_, index) => <MdStar key={index} className="text-review" />)}
//         {halfStars === 1 && <MdStarHalf className="text-review" />}
//         {Array(emptyStars).fill().map((_, index) => <MdStarOutline key={index} className="text-review" />)}
//       </div>
//     );
//   };

//   const handleSmallImageClick = (clickedTestimonial) => {
//     setIsFading(true);
//     setTimeout(() => {
//       setActiveTestimonial(clickedTestimonial);
//       setSmallImages((prevSmallImages) =>
//         prevSmallImages.filter((item) => item !== clickedTestimonial).concat(activeTestimonial)
//       );
//       setIsFading(false);
//     }, slideDuration);
//   };

//   const handleNextLarge = () => {
//     if (!isSliding) {
//       setIsSliding(true);
//       setTimeout(() => {
//         setActiveTestimonial((prev) => {
//           const updatedSmallImages = [
//             prev,
//             ...smallImages.slice(0, smallImages.length - 1)
//           ];
//           return updatedSmallImages[0];
//         });
//         setIsSliding(false);
//       }, slideDuration);
//     }
//   };

//   const handlePrevLarge = () => {
//     if (!isSliding) {
//       setIsSliding(true);
//       setTimeout(() => {
//         setActiveTestimonial((prev) => {
//           const updatedSmallImages = [
//             ...smallImages.slice(1),
//             prev
//           ];
//           return updatedSmallImages[updatedSmallImages.length - 1];
//         });
//         setIsSliding(false);
//       }, slideDuration);
//     }
//   };

//   const handlers = useSwipeable({
//     onSwipedLeft: handleNextLarge,
//     onSwipedRight: handlePrevLarge,
//     preventDefaultTouchmoveEvent: true,
//     trackMouse: true,
//   });

//   if (!activeTestimonial) {
//     return null;
//   }

//   return (
//     <div {...handlers} className="mx-auto h-full px-4 pt-2 pb-20 lg:pb-48 2xl:pb-32 xl:py-5 relative bg-tertiary overflow-hidden"> 
//     <h2 className="text-3xl font-outfit font-light text-center -mb-10 text-primary1">TESTIMONIALS</h2>
    
//     <div className="hidden lg:flex relative lg:left-[35%] top-6 z-10">
//       <img src={icons.collectionFlower} alt="Doodle Left" className="lg:w-20" />
//     </div>
    
//     <div className="lg:hidden relative left-[3%] md:left-[26%] top-12 z-10">
//       <img src={icons.collectionFlower} alt="Doodle Left" className="w-16" />
//     </div>
    
//     <div className="hidden lg:flex relative lg:left-28">
//       <div className="flex-1 text-left relative top-10">
//         {renderStars(activeTestimonial.rating)}
//         <h3 className="text-3xl font-outfit font-normal text-primary1">{activeTestimonial.name}</h3>
//         <h4 className="text-2xl font-outfit font-light text-hcolor">{activeTestimonial.city}</h4>
//         <p className="text-md font-poppins font-light text-hcolor mt-5">{activeTestimonial.testimonial}</p>
        
//         <div className="flex space-x-1 mt-4 relative lg:top-32">
//           <div className='relative xl:top-80 2xl:top-36 right-2'>
//             <img src={icons.arrowLeft} alt="left arrow" className="text-hcolor cursor-pointer bg-secondary rounded-full h-7 w-7" onClick={handlePrevLarge} />
//           </div>
          
//           <div className='flex gap-x-4 relative right-7 xl:-bottom-60 2xl:-bottom-16'>
//             {smallImages.map((testimonial, index) => (
//               <div key={testimonial._id || index} className="flex flex-col items-center space-y-1">
//                 <img
//                   src={IMAGE_URL+testimonial.image}
//                   alt={testimonial.name}
//                   className="w-[180px] h-[180px] object-cover cursor-pointer transition-opacity duration-500 hover:opacity-80"
//                   onClick={() => handleSmallImageClick(testimonial)}
//                 />
//                 {renderStars(testimonial.rating)}
//                 <h4 className="text-md font-outfit font-normal text-primary1 whitespace-nowrap truncate">{testimonial.name}</h4>
//               </div>
//             ))}
//           </div>
          
//           <div className='relative xl:top-80 2xl:top-36 right-10'>
//             <img src={icons.arrowRight} alt="right arrow" className="text-hcolor cursor-pointer bg-secondary rounded-full h-7 w-7" onClick={handleNextLarge} />
//           </div>
//         </div>
//       </div>
      
//       <div className="flex-1 relative left-8">
//         <img
//           src={IMAGE_URL+activeTestimonial.image}
//           alt={activeTestimonial.name}
//           className="lg:w-[300px] xl:w-[480px] 2xl:w-[530px] lg:h-[100%]  pt-12 xl:py-12 xl:pr-10 object-cover transition-opacity duration-500"
//         />
//       </div>
//     </div>
    
//     <div className="lg:hidden flex flex-col items-center">
//       <img
//         src={IMAGE_URL+activeTestimonial.image}
//         alt={activeTestimonial.name}
//         className="w-[85%] md:w-full h-auto md:h-[50%] object-cover mb-4 md:max-w-[680px] transition-opacity duration-500"
//       />
//       <div className="flex flex-col items-start w-full relative left-7 md:left-10">
//         {renderStars(activeTestimonial.rating)}
//         <h3 className="text-3xl font-outfit font-normal text-primary1">{activeTestimonial.name}</h3>
//         <h4 className="text-2xl font-outfit font-light text-hcolor">{activeTestimonial.city}</h4>
//         <p className="text-md font-poppins font-light text-hcolor mt-1">{activeTestimonial.testimonial}</p>
//       </div>
      
//       <div className="flex space-x-5 mb-4 mt-16 relative left-2 md:left-0">
//         {smallImages.map((testimonial, index) => (
//           <div key={testimonial._id || index} className="flex flex-col items-center space-y-1">
//             <img
//               src={IMAGE_URL+testimonial.image}
//               alt={testimonial.name}
//               className="w-[100px] h-[100px] object-cover rounded-md transition-opacity duration-500 hover:opacity-80"
//               onClick={() => handleSmallImageClick(testimonial)}
//             />
//             {renderStars(testimonial.rating)}
//             <h4 className="text-sm font-outfit font-normal text-primary1">{testimonial.name}</h4>
//           </div>
//         ))}
//       </div>
      
//       <div className="relative flex justify-between items-center mt-8">
//         <img src={icons.arrowLeft} alt="left arrow" className="text-hcolor cursor-pointer bg-secondary rounded-full h-7 w-7" onClick={handlePrevLarge} />
//         <img src={icons.arrowRight} alt="right arrow" className="text-hcolor cursor-pointer bg-secondary rounded-full h-7 w-7" onClick={handleNextLarge} />
//       </div>
//     </div>
//   </div>
  
//   );
// };

// export default Testimonials;


import React, { useState, useEffect } from "react";
import { MdStar, MdStarHalf, MdStarOutline } from "react-icons/md";
import { useSwipeable } from "react-swipeable";
import icons from '../../../icons.config';
import { IMAGE_URL } from "../../../api-urls";

const Testimonials = ({ testimonialsData }) => {
  const [activeTestimonial, setActiveTestimonial] = useState(null);
  const [smallImages, setSmallImages] = useState([]);
  const [isFading, setIsFading] = useState(false);
  const [isSliding, setIsSliding] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [smallScreenIndex, setSmallScreenIndex] = useState(0);
  const [showPopup, setShowPopup] = useState(false);
  const [selectedTestimonial, setSelectedTestimonial] = useState(null);
  const slideDuration = 500;
  const maxVisibleSmallImages = 4;
  const maxVisibleSmallImagesMobile = 2;
  const wordLimit = 69;

  useEffect(() => {
    if (testimonialsData && testimonialsData.length > 0) {
      setActiveTestimonial(testimonialsData[0]);
      setSmallImages(testimonialsData.slice(1));
      setCurrentIndex(0);
      setSmallScreenIndex(0);
    }
  }, [testimonialsData]);

  const countWords = (text) => {
    if (!text) return 0;
    return text.trim().split(/\s+/).length;
  };

  const truncateDescription = (text) => {
    if (!text) return "";
    const words = text.trim().split(/\s+/);
    if (words.length <= wordLimit) return text;
    return words.slice(0, wordLimit).join(" ") + "...";
  };

  const renderStars = (rating) => {
    if (!rating) return null;
    const fullStars = Math.floor(rating);
    const halfStars = rating % 1 !== 0 ? 1 : 0;
    const emptyStars = 5 - fullStars - halfStars;

    return (
      <div className="flex space-x-1">
        {Array(fullStars).fill().map((_, index) => <MdStar key={index} className="text-review" />)}
        {halfStars === 1 && <MdStarHalf className="text-review" />}
        {Array(emptyStars).fill().map((_, index) => <MdStarOutline key={index} className="text-review" />)}
      </div>
    );
  };

  const handleSmallImageClick = (clickedTestimonial) => {
    setIsFading(true);
    setTimeout(() => {
      setActiveTestimonial(clickedTestimonial);
      setSmallImages((prevSmallImages) => {
        const updated = prevSmallImages.filter((item) => item !== clickedTestimonial);
        return [...updated, activeTestimonial];
      });
      setSmallScreenIndex(0);
      setIsFading(false);
    }, slideDuration);
  };

  const handleNext = () => {
    if (!isSliding) {
      setIsSliding(true);
      setTimeout(() => {
        setActiveTestimonial(smallImages[0]);
        setSmallImages((prev) => {
          const updated = [...prev.slice(1), activeTestimonial];
          setCurrentIndex((prevIndex) => Math.min(prevIndex + 1, updated.length - maxVisibleSmallImages));
          setSmallScreenIndex(0);
          return updated;
        });
        setIsSliding(false);
      }, slideDuration);
    }
  };

  const handlePrev = () => {
    if (!isSliding) {
      setIsSliding(true);
      setTimeout(() => {
        setActiveTestimonial(smallImages[smallImages.length - 1]);
        setSmallImages((prev) => {
          const updated = [activeTestimonial, ...prev.slice(0, prev.length - 1)];
          setCurrentIndex((prevIndex) => Math.max(prevIndex - 1, 0));
          setSmallScreenIndex(0);
          return updated;
        });
        setIsSliding(false);
      }, slideDuration);
    }
  };

  const handleNextSmallScreen = () => {
    if (!isSliding && smallScreenIndex < smallImages.length - maxVisibleSmallImagesMobile) {
      setIsSliding(true);
      setTimeout(() => {
        setSmallScreenIndex((prev) => prev + 1);
        setIsSliding(false);
      }, slideDuration);
    }
  };

  const handlePrevSmallScreen = () => {
    if (!isSliding && smallScreenIndex > 0) {
      setIsSliding(true);
      setTimeout(() => {
        setSmallScreenIndex((prev) => prev - 1);
        setIsSliding(false);
      }, slideDuration);
    }
  };

  const openPopup = (testimonial) => {
    setSelectedTestimonial(testimonial);
    setShowPopup(true);
  };

  const closePopup = () => {
    setShowPopup(false);
    setSelectedTestimonial(null);
  };

  const handlers = useSwipeable({
    onSwipedLeft: handleNext,
    onSwipedRight: handlePrev,
    preventDefaultTouchmoveEvent: true,
    trackMouse: true,
  });

  const handlersSmallScreen = useSwipeable({
    onSwipedLeft: handleNextSmallScreen,
    onSwipedRight: handlePrevSmallScreen,
    preventDefaultTouchmoveEvent: true,
    trackMouse: true,
  });

  if (!activeTestimonial) {
    return null;
  }

  const visibleSmallImages = smallImages.slice(currentIndex, currentIndex + maxVisibleSmallImages);
  const visibleSmallImagesMobile = smallImages.slice(smallScreenIndex, smallScreenIndex + maxVisibleSmallImagesMobile);

  return (
    <div {...handlers} className="mx-auto h-full px-4 pt-2 pb-20 lg:pb-48 2xl:pb-32 xl:py-5 relative bg-tertiary overflow-hidden">
      <h2 className="text-3xl font-outfit font-light text-center -mb-10 text-primary1">TESTIMONIALS</h2>

      <div className="hidden lg:flex relative lg:left-[35%] -top-6 z-10">
        <img src={icons.collectionFlower} alt="Doodle Left" className="lg:w-20" />
      </div>

      <div className="lg:hidden relative left-[3%] md:left-[26%] top-6 z-10">
        <img src={icons.collectionFlower} alt="Doodle Left" className="w-16" />
      </div>

      {/* Popup */}
      {showPopup && selectedTestimonial && (
        <div
          className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50 backdrop-blur-sm"
          onClick={closePopup} // Close popup when clicking outside
        >
          <div
            className="bg-tertiary p-6 rounded-lg max-w-xl w-full relative max-h-[80vh] flex flex-col"
            onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside
          >
            <button
              onClick={closePopup}
              className="absolute top-2 right-2 text-hcolor text-2xl"
            >
              ×
            </button>
            <img
              src={IMAGE_URL + selectedTestimonial.image}
              alt={selectedTestimonial.name}
              className="w-full h-64 object-cover mb-4 rounded"
            />
            <h3 className="text-2xl font-outfit font-normal text-primary1 mb-2">{selectedTestimonial.name}</h3>
            <div className="max-h-72 overflow-y-auto">
              <p className="text-md font-poppins font-light text-hcolor">{selectedTestimonial.testimonial}</p>
            </div>
          </div>
        </div>
      )}

      {/* Large Screen Layout */}
      <div className="hidden lg:flex relative lg:left-20 xl:left-28 h-[650px] 2xl:h-[660px] gap-6">
        <div className="flex-1 text-left relative top-10">
          {renderStars(activeTestimonial.rating)}
          <h3 className="text-3xl font-outfit font-normal text-primary1">{activeTestimonial.name}</h3>
          <h4 className="text-2xl font-outfit font-light text-hcolor">{activeTestimonial.city}</h4>
          <p className="text-md font-poppins font-light text-hcolor mt-5">
            {countWords(activeTestimonial.testimonial) > wordLimit ? (
              <>
                {truncateDescription(activeTestimonial.testimonial)}{" "}
                <button
                  onClick={() => openPopup(activeTestimonial)}
                  className="text-hcolor underline hover:text-primary1"
                >
                  Read More
                </button>
              </>
            ) : (
              activeTestimonial.testimonial
            )}
          </p>

          <div className="flex items-center mt-4 relative lg:top-48 xl:top-16 2xl:top-24">
            <div className="relative -top-4">
              <img
                src={icons.arrowLeft}
                alt="left arrow"
                className="text-hcolor cursor-pointer bg-secondary rounded-full h-7 w-7"
                onClick={handlePrev}
              />
            </div>

            <div className="flex gap-x-4">
              {visibleSmallImages.map((testimonial, index) => (
                <div key={testimonial._id || index} className="flex flex-col items-center space-y-1">
                  <img
                    src={IMAGE_URL + testimonial.image}
                    alt={testimonial.name}
                    className="w-[180px] h-[180px] object-cover cursor-pointer transition-opacity duration-500 hover:opacity-80"
                    onClick={() => handleSmallImageClick(testimonial)}
                  />
                  {renderStars(testimonial.rating)}
                  <h4 className="text-md font-outfit font-normal text-primary1 whitespace-nowrap truncate">
                    {testimonial.name}
                  </h4>
                </div>
              ))}
            </div>

            <div className="relative -top-4">
              <img
                src={icons.arrowRight}
                alt="right arrow"
                className="text-hcolor cursor-pointer bg-secondary rounded-full h-7 w-7"
                onClick={handleNext}
              />
            </div>
          </div>

          <div className="flex justify-center space-x-2 mt-4">
            {smallImages.map((_, index) => (
              <div
                key={index}
                className={`w-3 h-3 rounded-full ${
                  index === smallImages.indexOf(activeTestimonial) ? "bg-hcolor" : "bg-gray-300"
                }`}
              />
            ))}
          </div>
        </div>

        <div className="flex-1 relative py-12">
          <img
            src={IMAGE_URL + activeTestimonial.image}
            alt={activeTestimonial.name}
            className="w-[70%] h-full object-cover transition-opacity duration-500"
          />
        </div>
      </div>

      {/* Small Screen Layout */}
      <div className="lg:hidden flex flex-col items-center h-screen mx-auto">
        <img
          src={IMAGE_URL + activeTestimonial.image}
          alt={activeTestimonial.name}
          className="w-full h-[60%] object-cover mb-4 transition-opacity duration-500"
        />
        <div className="flex flex-col items-start w-full relative">
          {renderStars(activeTestimonial.rating)}
          <h3 className="text-3xl font-outfit font-normal text-primary1">{activeTestimonial.name}</h3>
          <h4 className="text-2xl font-outfit font-light text-hcolor">{activeTestimonial.city}</h4>
          <p className="text-md font-poppins font-light text-hcolor mt-1">
            {countWords(activeTestimonial.testimonial) > wordLimit ? (
              <>
                {truncateDescription(activeTestimonial.testimonial)}{" "}
                <button
                  onClick={() => openPopup(activeTestimonial)}
                  className="text-hcolor underline hover:text-primary1"
                >
                  Read More
                </button>
              </>
            ) : (
              activeTestimonial.testimonial
            )}
          </p>
        </div>

        <div className="w-full flex flex-col items-center">
          <div {...handlersSmallScreen} className="flex space-x-5 mb-4 mt-8 relative overflow-x-auto">
            {visibleSmallImagesMobile.map((testimonial, index) => (
              <div key={testimonial._id || index} className="flex flex-col items-center space-y-1 min-w-[120px]">
                <img
                  src={IMAGE_URL + testimonial.image}
                  alt={testimonial.name}
                  className="w-[100px] h-[100px] object-cover transition-opacity duration-500 hover:opacity-80"
                  onClick={() => handleSmallImageClick(testimonial)}
                />
                {renderStars(testimonial.rating)}
                <h4 className="text-sm font-outfit font-normal text-primary1">{testimonial.name}</h4>
              </div>
            ))}
          </div>

          <div className="flex justify-center space-x-2 mb-4">
            {smallImages.map((_, index) => (
              <div
                key={index}
                className={`w-3 h-3 rounded-full ${
                  index >= smallScreenIndex && index < smallScreenIndex + maxVisibleSmallImagesMobile
                    ? "bg-hcolor"
                    : "bg-gray-300"
                }`}
              />
            ))}
          </div>
        </div>

        <div className="relative flex justify-between items-center w-full px-4">
          <div className="flex space-x-2">
            {smallImages.map((_, index) => (
              <div
                key={index}
                className={`w-3 h-3 rounded-full ${
                  index === smallImages.indexOf(activeTestimonial) ? "bg-hcolor border-hcolor" : "bg-tertiary border-hcolor"
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;